import { MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

export const COMMENT_MAX = 2000

export interface CommentDialogData {
    comment?:string
    title?:string       // what the comment is about, such as the insights section
    note?:string        // how the comment is kept, shown under the box
}

// edits a comment; closes with the new text ('' removes it), or undefined when cancelled
@Component({
    selector: 'app-comment-dialog',
    templateUrl: './comment-dialog.html',
    styleUrls: ['./comment-dialog.css'],
    standalone: false
})
export class CommentDialogComponent {
    commentControl:FormControl<string>
    COMMENT_MAX = COMMENT_MAX

    constructor(public dialogRef: MatDialogRef<CommentDialogComponent, string>, @Inject(MAT_DIALOG_DATA) public data: CommentDialogData) {
        this.commentControl = new FormControl(data?.comment || '', {nonNullable:true, validators:Validators.maxLength(COMMENT_MAX)})
    }

    get isNew() {
        return !this.data?.comment
    }

    // shown the same way as on the page: line breaks kept, and the html sanitised by Angular
    get preview() {
        return this.commentControl.value.trim().replace(/\n/g, '<br>')
    }

    onSave(): void {
        if (this.commentControl.invalid) return
        this.dialogRef.close(this.commentControl.value.trim());
    }

    onRemove(): void {
        this.dialogRef.close('');
    }
}
